import {useEffect} from 'react';
import {Asset} from '@deviceinsight/ng-ui-api-client';
import {sendButtonPressedEvent} from '../../../api/eventsApi';
import {ButtonInfo} from '../../widgets/floorplan/types';
import {BUTTON_NAME_MAPPING} from '../../../modules/common/consts';

type ButtonName = 'button1' | 'button2';

const useButtonTriggers = (
	asset: Asset | null | undefined,
	isOnline: boolean | null | undefined,
	buttonInfo: ButtonInfo | null | undefined,
	setButtonInfo: (arg0: ButtonInfo | undefined) => void = () => {
		//
	}
) => {
	useEffect(() => {
		if (buttonInfo && isOnline && asset) {
			const {dataPointName} = buttonInfo;
			const buttonName = BUTTON_NAME_MAPPING[dataPointName as ButtonName];
			sendButtonPressedEvent(asset, dataPointName, buttonName);
			setButtonInfo(undefined);
		}

		return () => {
			setButtonInfo(undefined);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [buttonInfo]);
};

export default useButtonTriggers;
